import React from 'react';

const TableHead = () => (
    <thead className="thead-light">
        <tr>
            <th scope="col">Modelo</th>
            <th scope="col">Nome</th>
            <th scope="col">Número Lógico</th>
            <th scope="col">Número Serial</th>
            <th scope="col">Estabelecimento</th>
            <th scope="col">Status</th>
            <th scope="col"></th>
        </tr>
    </thead>
);

export default TableHead;


// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/TableHead.js